import { Link } from "react-router-dom";

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="bg-slate-900 py-16 text-white md:py-20" data-testid="page-header">
      <div className="fg-container">
        <nav className="text-xs uppercase tracking-[0.2em] text-slate-400" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-blue-300">Home</Link>
          {eyebrow ? <span className="mx-2">/</span> : null}
          {eyebrow ? <span className="text-blue-300">{eyebrow}</span> : null}
        </nav>
        <h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">
            {subtitle}
          </p>
        ) : null}
        {children}
      </div>
    </section>
  );
}
